module.exports = __webpack_public_path__ + "img/benefits-slider-2.aa6beb76.png";